<script>
  import Terms from "$lib/admin/components/blocks/helpers/Terms.svelte";
  import Perks from "./blocks/Perks.svelte";
  import Logo from "./blocks/Logo.svelte";
  import Badges from "./blocks/Badges.svelte";
  import ClickToAction from "./blocks/ClickToAction.svelte";
  import Bonus from "./blocks/Bonus.svelte";
  import { translate } from "$lib/common/helpers/translate";

  export let props = null;
  export let operator = null;
  export let project = null;
  export let visibleOrNot = null;
  export let dataElement = null;
  export let toplistPosition = null;

  let lang = $project.settings.lang ?? "en";
  let primaryColor =
    operator.visuals[$project.key][$project.settings.market].primary_color;

  $: formattedPrimaryColor = primaryColor.replace(/\s+/g, "");
  $: borderColor =
    formattedPrimaryColor === "255,255,255,1" ? "" : `rgba(${primaryColor})`;

  // Perks Data:
  // No Account
  let noAccount = operator.data.features?.[$project.settings.market].no_account
    ? translate("Yes", lang)
    : translate("No2", lang);

  // Payment Methods
  let paymentMethods =
    operator.data.deposit[$project.settings.market].join(", ");

  // Fast Registration
  let fastRegistration = operator.data.features?.[$project.settings.market]
    .fast_registration
    ? translate("Yes", lang)
    : translate("No2", lang);

  // Pay'n Play
  let payNPlay = operator.data.features?.[$project.settings.market].pay_n_play
    ? translate("Yes", lang)
    : translate("No2", lang);

  let perksData = [
    {
      title: translate("Without account", lang),
      value: noAccount,
    },
    {
      title: translate(["Fast registration"], lang),
      value: fastRegistration,
    },
    {
      title: translate(["Pay'n Play"], lang),
      value: payNPlay,
    },
    {
      title: translate("Deposit methods", lang),
      value: paymentMethods,
    },
  ];
</script>

<div style="display: {visibleOrNot}">
  <div class="operator-container" style="border-color: {borderColor};">
    <Logo {operator} {primaryColor} {dataElement} {toplistPosition} />
    <Badges {operator} {project} />
    <Bonus {operator} {project} />
    <Perks perks={perksData} theme="no-account" />
    <ClickToAction
      {operator}
      {project}
      {props}
      {dataElement}
      {toplistPosition}
    />
  </div>
  <div class="terms-container">
    <Terms {operator} />
  </div>
</div>

<style>
  .operator-container {
    position: relative;
    display: grid;
    grid-template-columns: 125px 1fr;
    grid-template-rows: 0fr 55px 0fr 1fr;
    grid-template-areas:
      "LOGO BONUS"
      "LOGO BADGES"
      "LOGO CTA"
      "PERKS PERKS";
    border-radius: 10px;
    background-color: #fff;
    border: 2px solid rgba(217, 217, 217, 1);
    overflow: hidden;
    @media only screen and (min-width: 992px) {
      height: 190px;
      grid-auto-flow: column;
      grid-template-columns: 165px 55px 1.2fr 1.7fr 1fr;
      grid-template-rows: 1fr 1fr 1fr;
      grid-template-areas:
        "LOGO BADGES BONUS PERKS CTA"
        "LOGO BADGES BONUS PERKS CTA"
        "LOGO BADGES BONUS PERKS CTA";
    }
  }
  .terms-container {
    text-align: center;
    font-size: 12px;
    font-weight: 300;
    & a {
      color: var(--clr-qua);
      text-decoration: underline;
      font-weight: 300;
    }
  }
</style>
